import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { 
    Grid, Typography, FormControl, InputLabel, Button, OutlinedInput, InputAdornment, IconButton, Badge, Box, Card
} from '@mui/material';
import { MyContext } from '../MyContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import axios from "axios";
import Helpers from "../Helpers";
import CardProduto from "../components/CardProduto";

const docHeigth = window.innerHeight;
const docWidth = window.innerWidth;
let styles = {};

if(docWidth > 420){
    styles = {
        listaSubgrupos: {
            display: 'inline-block',
            minWidth: 140,
            marginRight: 2,
            padding: 1,
            cursor: 'pointer'
        },
        textSubgrupos: {
            fontWeight: 'bold',
            textAlign: 'center'
        },
        divPaginator: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
        },
        btnPaginator: {
            marginLeft: 1,
            marginBottom: 1,
            borderWidth: 1,
            borderRadius: 1,
            borderColor: '#353B48',
            backgroundColor: '#FFF',
            color: '#353B48',
            fontSize: '1rem',
            fontWeight: 'bold',
        },
        btnPaginatorActive: {
            marginLeft: 1,
            marginBottom: 1,            
            borderWidth: 1,
            borderRadius: 1,
            borderColor: '#353B48',
            backgroundColor: '#353B48',
            color: '#F5F5F5',
            fontSize: '1rem',
            fontWeight: 'bold',
        },
    };
}else{
    styles = {
        listaSubgrupos: {
            display: 'inline-block',
            minWidth: 100,
            marginRight: 2,
            padding: 1,
        },
        textSubgrupos: {
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: 13
        },
        divPaginator: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
        },
        btnPaginator: {
            marginLeft: 1,
            marginBottom: 1,
            borderWidth: 1,
            borderRadius: 1,
            borderColor: '#353B48',
            backgroundColor: '#FFF',
            color: '#353B48',
            fontSize: '1rem',
            fontWeight: 'bold',
        },
        btnPaginatorActive: {
            marginLeft: 1,
            marginBottom: 1,
            borderWidth: 1,
            borderRadius: 1,
            borderColor: '#353B48',
            backgroundColor: '#353B48',
            color: '#F5F5F5',
            fontSize: '1rem',
            fontWeight: 'bold',
        },
    };
}

function Produtos(){
    const navigate = useNavigate();
    const location = useLocation();
    const idClient = location.state?.idCliente;
    const { listaCarrinho } = useContext(MyContext);
    const [itensPorPagina, setItensPorPagina] = useState(12);
    const [paginaAtual, setPaginaAtual] = useState(0);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [clienteId, setClienteId] = useState(idClient);
    const [dsCliente, setDsCliente] = useState('');
    const [listaProdutos, setlistaProdutos] = useState([]);
    const [listaSubgrupos, setlistaSubgrupos] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [inputPesquisa, setInputPesquisa] = useState('');

    useEffect(()=>{
        setPaginaAtual(0);
    }, [itensPorPagina]);

    const paginacao = Helpers.paginacao(listaFiltrada, itensPorPagina, paginaAtual);
    const paginas = paginacao.paginas;
    const listaAtual = paginacao.lista;
    const botoes = Helpers.gerarBotoes(paginaAtual, paginas);

    useEffect(()=>{
        if(!idClient){
            navigate('/clientes');
        }
    }, [idClient]);

    const getProdutosApi = async(cliente_id)=>{
        Helpers.loadingAlert('Atualizando lista de produtos');
        const rota = `${urlApi}/${cliente_id}/produtos`;
        const resposta = await axios.get(rota);

        setlistaProdutos(resposta.data.produtos);
        setListaFiltrada(resposta.data.produtos);
        setlistaSubgrupos(resposta.data.subgrupos);
    };

    const getCliente = ()=>{
        const data = localStorage.getItem('clienteSelecionado');

        if(data != null){
            let cliente = JSON.parse(data);
            setDsCliente(cliente.nmFantasia);
        }
    };

    useEffect(() => {
        if(urlApi){
            getCliente();
            getProdutosApi(clienteId);
        }
    }, [urlApi]);

    const handleFiltraRegistro = (input)=>{
        Helpers.loadingAlert('Filtrando produtos');
        let registro = input;

        if(registro == ''){
            setInputPesquisa('');
            setListaFiltrada(listaProdutos);
            
            return Helpers.toastAlert({
                title: 'Lista de produtos atualizada',
                icon: 'success'
            });
        }

        const resultado = listaProdutos.filter(item => {
            let ds_registro = item.nm_produto;
            return ds_registro.toLowerCase().includes(registro.toLowerCase());
        });

        if(resultado.length > 0){
            setListaFiltrada(resultado);
        }else{
            setListaFiltrada(listaProdutos);
            return Helpers.toastAlert({
                title: 'Nenhum registro encontrado.',
                icon: 'warning'
            });
        }

        setInputPesquisa(registro);
    };

    const filtraSubgrupo = (id) => {
        let registro = id;

        if (registro == 0) {
            setListaFiltrada(listaProdutos);
            return;
        }

        const resultado = listaProdutos.filter(item => Number(item.id_subgrupo) === Number(registro));

        if (resultado.length > 0) {
            setListaFiltrada(resultado);
        } else {
            setListaFiltrada(listaProdutos);
            return Helpers.toastAlert({
                title: 'Nenhum registro encontrado para este sub grupo',
                icon: "error",
            });
        }
    };

    const produtoCarrinho = (item) => {
        let registro = {};
        const result = listaCarrinho.filter(val => Number(val.idProduto) === Number(item.id_produto));

        if(result && result.length > 0){
            registro = {
                idCliente: result[0].idCliente,
                idProduto: result[0].idProduto,
                cdProduto: item.cd_produto,
                nmProduto: result[0].nmProduto,
                cmImagem: item.cm_imagem,
                dsUnidade: item.ds_unidade,
                vrProduto: result[0].vrProduto,
                dsTravaEstoque: result[0].dsTravaEstoque ?? 'S',
                dsEstoqueAtual: item.estoque_atual,
                qtProduto: result[0].qtProduto,
                dsObs: result[0].dsObs,
                adicionado: true,
                vr_unitario: item.vr_unitario,
                valor_final: item.valor_final,
                valor_base: item.valor_base,
                vr_custo: item.vr_custo,
                vr_custofp: item.vr_custofp,
                valor_st: item.valor_st,
                vr_mva: item.vr_mva,
                vr_aliquotaicms: item.vr_aliquotaicms,
                vr_aliquotaicmsst: item.vr_aliquotaicmsst,
                vr_redubaseicms: item.vr_redubaseicms,
                vr_alqpobreza: item.vr_alqpobreza,
                alqpobreza: item.alqpobreza,
                vbcfcpst: item.vbcfcpst,
                ds_modalbcicmsst: item.ds_modalbcicmsst,
                id_cfop: item.id_cfop,
                id_almoxarifado: item.id_almoxarifado,
                id_cst: item.id_cst,
                id_cstipi: item.id_cstipi,
                id_csosn: item.id_csosn,
                id_estoqueprod: item.id_estoqueprod,
                id_cstpis: item.id_cstpis,
                id_cstcofins: item.id_cstcofins,
                id_origemprodnfe: item.id_origemprodnfe,
                id_nbm: item.id_nbm,
                id_operacaofiscal: item.id_operacaofiscal,
                id_enquadraipi: item.id_enquadraipi,
                id_cest: item.id_cest,
            }
        }else{
            registro = {
                idCliente: item.id_cliente,
                idProduto: item.id_produto,
                cdProduto: item.cd_produto,
                nmProduto: item.nm_produto,
                cmImagem: item.cm_imagem,
                dsUnidade: item.ds_unidade,
                vrProduto: item.valor_final,
                dsTravaEstoque: item.ds_travaestoque ?? 'S',
                dsEstoqueAtual: item.estoque_atual,
                qtProduto: 1,
                dsObs: '',
                adicionado: false,
                vr_unitario: item.vr_unitario,
                valor_final: item.valor_final,
                valor_base: item.valor_base,
                vr_custo: item.vr_custo,
                vr_custofp: item.vr_custofp,
                valor_st: item.valor_st,
                vr_mva: item.vr_mva,
                vr_aliquotaicms: item.vr_aliquotaicms,
                vr_aliquotaicmsst: item.vr_aliquotaicmsst,
                vr_redubaseicms: item.vr_redubaseicms,
                vr_alqpobreza: item.vr_alqpobreza,
                alqpobreza: item.alqpobreza,
                vbcfcpst: item.vbcfcpst,
                ds_modalbcicmsst: item.ds_modalbcicmsst,
                id_cfop: item.id_cfop,
                id_almoxarifado: item.id_almoxarifado,
                id_cst: item.id_cst,
                id_cstipi: item.id_cstipi,
                id_csosn: item.id_csosn,
                id_estoqueprod: item.id_estoqueprod,
                id_cstpis: item.id_cstpis,
                id_cstcofins: item.id_cstcofins,
                id_origemprodnfe: item.id_origemprodnfe,
                id_nbm: item.id_nbm,
                id_operacaofiscal: item.id_operacaofiscal,
                id_enquadraipi: item.id_enquadraipi,
                id_cest: item.id_cest,
            }
        }

        return registro;
    }

    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid 
                size={12} 
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row', 
                    alignItems: 'center',
                    gap: 2 
                }}
            >
                <Button 
                    variant="contained" 
                    size="small" 
                    startIcon={<ArrowBackIcon />} 
                    onClick={()=> navigate('/clientes')}
                    sx={{ backgroundColor: '#f5f5f5', color: 'rgba(0,0,0, .8)' }}
                > 
                    sair
                </Button>

                <Typography
                    sx={{
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        fontSize: 14,
                    }}
                >
                    Lista de produtos
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} offset={{ md: 3 }} >
                <Box style={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                    <Typography
                        sx={{
                            fontStyle: 'italic',
                            textTransform: 'uppercase',
                            fontSize: 12,
                        }}
                    >
                        Cliente: 
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            fontSize: 14,
                        }}
                    >
                        {dsCliente}
                    </Typography>
                </Box>

                <FormControl fullWidth variant="outlined" sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                    <InputLabel htmlFor="outlined-adornment-password">Pesquisar produto</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'search'}
                        value={inputPesquisa}
                        onChange={(e) => setInputPesquisa(e.target.value.slice(0,120))}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={()=>handleFiltraRegistro(inputPesquisa)}
                                    edge="end"
                                >
                                    <ContentPasteSearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Pesquisar cliente"
                    />
                </FormControl>

                <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', padding: 2 }}>
                    <Card key={'-1'} sx={styles.listaSubgrupos} onClick={()=>filtraSubgrupo(0)} >
                        <Typography sx={styles.textSubgrupos}>TODOS</Typography>
                    </Card>
                    {listaSubgrupos.map((item, index) => (
                        <Card key={index} sx={styles.listaSubgrupos} onClick={()=>filtraSubgrupo(item.id)} >
                            <Typography sx={styles.textSubgrupos}>{item.ds_subgrupo}</Typography>
                        </Card>
                    ))}
                </Box>
            </Grid>

            <Grid
                size={{ xs: 12, md: 12 }} 
                sx={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 1,
                    paddingX: 2,
                    borderBottom: '3px solid #DA0C16'
                }}
            >
                <Typography sx={{ fontWeight: 'bold', fontSize: 15, textTransform: 'uppercase' }}>{`${listaFiltrada.length} produtos encontrados`} </Typography>
                {
                    (listaCarrinho.length > 0) && (
                        <Badge
                            badgeContent={listaCarrinho.length}
                            color="primary"
                            onClick={()=>navigate('/checkout')}
                            sx={{ cursor: 'pointer' }}
                        >
                            <ShoppingCartCheckoutIcon color="action" />
                        </Badge>
                    )
                }
            </Grid>

            <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                {
                    (listaAtual.length > 0) &&
                    listaAtual.map((item, index)=>{
                        return (
                            <CardProduto 
                                key={item.id_produto}
                                produto={produtoCarrinho(item)} 
                            />
                        )                        
                    })
                }
            </Grid>

            <Grid sx={styles.divPaginator}>
                {/* Anterior */}
                <Button sx={styles.btnPaginator} onClick={() => setPaginaAtual(Math.max(0, paginaAtual - 1))}>&lsaquo;</Button>

                {/* Páginas */}
                {botoes.map((p, index) => (
                    <Button
                        key={index}
                        onClick={() => typeof p === 'number' && setPaginaAtual(p)}
                        disabled={p === '...'}
                        sx={(p === paginaAtual) ? styles.btnPaginatorActive : styles.btnPaginator}
                    >
                        {p === '...' ? '...' : p + 1}
                    </Button>
                ))}

                {/* Próximo */}
                <Button sx={styles.btnPaginator} onClick={() => setPaginaAtual(Math.min(paginas - 1, paginaAtual + 1))}>&rsaquo;</Button>
            </Grid>
        </Grid>
    );
}

export default Produtos;